export const Keyboard = -1

export const LeftClick = 0

export const MiddleClick = 1

export const RightClick = 2
